import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined'
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined'
import { useAuth } from '../../../auth/AuthContext'
import type { PermisoEnum } from '../../../model/kartera-api-model'
import * as Permisos from '../../../utils/Permisos'

export const SETTINGS_PATH = '/configuracion'

export interface SettingsItem {
    to: string
    label: string
    description: string
    Icon: typeof AccountCircleOutlinedIcon
    tone: string
    permisos?: PermisoEnum[]
    ready?: boolean
}

export interface SettingsGroup {
    id: string
    title: string
    items: SettingsItem[]
}

const GROUPS: SettingsGroup[] = [
    {
        id: 'cuenta',
        title: 'Tu cuenta',
        items: [
            { to: `${SETTINGS_PATH}/mi-cuenta`, label: 'Mi cuenta', description: 'Datos personales, celular y contraseña.', Icon: AccountCircleOutlinedIcon, tone: 'bg-tone-blue text-tone-blue-ink', ready: true },
            { to: `${SETTINGS_PATH}/mi-plan`, label: 'Facturación (Mi plan)', description: 'Plan contratado, vigencia y pagos.', Icon: CreditCardOutlinedIcon, tone: 'bg-tone-teal text-tone-teal-ink', permisos: [Permisos.FACTURACION], ready: true },
        ],
    },
    {
        id: 'agencia',
        title: 'Agencia',
        items: [
            { to: `${SETTINGS_PATH}/empresa`, label: 'Empresa', description: 'Razón social, logo, contacto y redes sociales.', Icon: ApartmentOutlinedIcon, tone: 'bg-tone-purple text-tone-purple-ink', permisos: [Permisos.EMPRESA_W], ready: true },
            { to: `${SETTINGS_PATH}/usuarios`, label: 'Usuarios', description: 'Usuarios adicionales y sus permisos.', Icon: PersonOutlinedIcon, tone: 'bg-tone-orange text-tone-orange-ink', permisos: [Permisos.USUARIOS_D], ready: true },
            { to: '/claves', label: 'Claves de agente', description: 'Claves por aseguradora.', Icon: AssignmentIndOutlinedIcon, tone: 'bg-tone-pink text-tone-pink-ink', permisos: [Permisos.CLAVES_W], ready: true },
            { to: `${SETTINGS_PATH}/vencimientos`, label: 'Fechas de vencimiento', description: 'Días de aviso para recibos y renovaciones.', Icon: EventAvailableOutlinedIcon, tone: 'bg-tone-blue text-tone-blue-ink', permisos: [Permisos.CONFIG], ready: true },
            { to: `${SETTINGS_PATH}/metas`, label: 'Metas', description: 'Objetivos de venta de la agencia.', Icon: BarChartOutlinedIcon, tone: 'bg-tone-teal text-tone-teal-ink', permisos: [Permisos.METAS], ready: true },
            { to: `${SETTINGS_PATH}/modelos`, label: 'Correos electrónicos', description: 'Plantillas de correos y comunicados.', Icon: EmailOutlinedIcon, tone: 'bg-tone-purple text-tone-purple-ink', permisos: [Permisos.COMUNICADOS_W], ready: true },
            { to: `${SETTINGS_PATH}/integraciones`, label: 'Integraciones', description: 'Conexión con herramientas externas.', Icon: WidgetsOutlinedIcon, tone: 'bg-tone-orange text-tone-orange-ink', permisos: [Permisos.INTEGRACIONES], ready: true },
        ],
    },
]

export const useSettingsMenuModel = () => {
    const { canAccess } = useAuth()

    const groups = GROUPS
        .map((group) => ({ ...group, items: group.items.filter((item) => !item.permisos || canAccess(item.permisos)) }))
        .filter((group) => group.items.length > 0)

    return {
        groups,
        linkState: { backUrl: SETTINGS_PATH },
    }
}
